const languages = {
  en: 'English',
  id: 'Bahasa',
  de: 'Deutsch',
  es: 'Español',
  fa: 'فارسی',
  fr: 'Français',
  hi: 'हिंदी',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  nl: 'Nederlands',
  th: 'ภาษาไทย',
  vi: 'Tiếng Việt',
  zh: '简体中文',
  tw: '繁體中文'
}

export default languages
